//
//
//
//
//
//
//
//
//

// Imports
import config from '~/config'

// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/)

// Layout
const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    return components
  }, {})

// Export Module
export default {
  el: '#app',
  name: 'App',

  metaInfo () {
    // const { appName } = window.config

    return {
      title: config.appTitle || 'Application',
      titleTemplate: `%s · ${config.appName}`,
    }
  },

  data: () => ({
      app: config.appTitle,
      version: config.version,
      config,
      layout: null,
      defaultLayout: 'default'
  }),

  mounted () {
      this.$loading = this.$refs.loading
  },

  methods: {
      /**
       * Set the application layout.
       *
       * @param {String} layout
       */
      setLayout (layout) {
        if (!layout || !layouts[layout]) {
          // console.log(':: Layout not set')
          layout = this.defaultLayout
        }

        this.layout = layouts[layout]
      }
  }
}
